import { useNavigate, useParams } from "react-router-dom";
import { Form, FormikProvider, useFormik } from "formik";
import { decode as base64_decode } from "base-64";
import { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";

export default function PaymentSuccess() {
  const { id } = useParams();
  let responsestring = base64_decode(id);
  let responsevalues = responsestring.split("###");
  let parsedObject = JSON.parse(responsevalues[0]);
  const formIk = useFormik({});
  const navigate = useNavigate();

  const user_id = sessionStorage.getItem('user_id');

  useEffect(() => {
    if (id !== '' || id !== null || id !== undefined) {
      localStorage.setItem("hasReloaded", "true");
    }
  }, []);

  function backtoHome() {
    if (user_id?.startsWith("2026")) {
      navigate("/home");
    } else {
      navigate("/NocDashboard");
    }
  }

  let componentRef = useRef();
  const handleprint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "PaymentPrint",

  });
  return (
    <>
      <header className="top-header top-headerfoot">
        <div className="par-logopart">
          <img src="../images/MAINLOGO.png" alt="" className="img-fluid" />

          <div className="paralogo-text">
            {/* <p className="mb-0">State Project Directorate</p>
                    <p className="mb-0">Rashtriya Uchchatar Shiksha Abhiyan (RUSA)</p> */}
            <h4 className="mb-0">
              Commissionerate of Higher Education</h4>
            <p className="mb-0"> Government of Andhra Pradesh</p>
          </div>
        </div>
      </header>

      {parsedObject?.auth_status !== "0300" ? (<>
        <FormikProvider value={formIk}>
          <Form onChange={formIk.handleChange} onSubmit={formIk.handleSubmit}>
            <jnb.Container>
              <jnb.Row>
                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                  <div className="page-titlespacing inner-herbpage-service-title1">
                  </div>
                </jnb.Col>
              </jnb.Row>
            </jnb.Container>
            <jnb.Container className="page-titlespacing outer-page-content-container">
              <div className="jumbotron mt20 form-card-jnb" style={{ marginTop: "5px" }} >
                <jnb.Row>
                  <jnb.Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9}></jnb.Col>
                  <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}
                  >
                  </jnb.Col>
                </jnb.Row>

                <table border="1" width="100%" role="presentation">
                  <tbody>
                    <tr>
                      <td align="center">
                        <h4>
                          <label style={{ color: "red", fontSize: "1.5rem" }}>
                            <h4> Your Payment Was {parsedObject?.status} for <label style={{ color: "red", fontSize: "1.5rem" }}> Rs. {parsedObject?.charge_amount}/- </label> on {parsedObject?.message}</h4>
                          </label>
                        </h4>
                      </td>
                    </tr>

                    <tr>
                      <td align="center">
                        <a href="/NocDashboard">
                          <button type="button" className="btn btn-sm btn-secondary" > Back to Payment Page </button>
                        </a>

                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </jnb.Container>
          </Form>
        </FormikProvider>
      </>) :
        (<>
          <FormikProvider value={formIk}>
            <Form onChange={formIk.handleChange} onSubmit={formIk.handleSubmit}>
              <jnb.Container>
                <jnb.Row>
                  <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <div className="page-titlespacing inner-herbpage-service-title1">
                    </div>
                  </jnb.Col>
                </jnb.Row>
              </jnb.Container>
              <br />
              <jnb.Container className="outer-page-content-container">
                <div className="jumbotr mt20 form-card-jnb pt-3" ref={componentRef}>

                  <font color="green">
                    <center>
                      <h4> Your Payment Was {parsedObject?.status} for <label style={{ color: "red", fontSize: "1.5rem" }}> Rs. {parsedObject?.charge_amount}/- </label> on {parsedObject?.payment_date}</h4>
                      <h4> Your Transaction Id is :<label style={{ color: "orange", fontSize: "1.5rem" }}>{parsedObject?.trans_id}</label></h4>
                      <h4> Reference Id for your Application : <label style={{ color: "orange", fontSize: "1.5rem" }}>{parsedObject?.order_id}</label></h4>
                      <h4> Please save this Transaction Id/ Reference Id for future reference.  </h4>
                    </center>
                  </font>
                </div>


                <jnb.Row>
                  <jnb.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}></jnb.Col>
                  <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                    <button
                      type="button"
                      className="btn btn-sm btn-secondary"
                      style={{ float: "right" }}
                      onClick={() => {
                        backtoHome();
                      }}
                    >
                      Click here to Dashboard
                    </button>
                  </jnb.Col>
                </jnb.Row>


              </jnb.Container>
            </Form>
          </FormikProvider>
        </>)}
      <footer className='forgot-footer' >
        <p className='mb-0'>Designed and Developed by <a href='https://apcfss.in/' target='_blank'>
          <img src='../images/footer-logo.svg' alt='' className='img-fluid' />
        </a>
        </p>
      </footer>

    </>
  );
}
